'use client';

import Image from 'next/image';

import { Typography } from '@components/typography';

const logos = [
  { src: '/assets/svg/list/pm-logos/skyrun.png', alt: 'SkyRun' },
  { src: '/assets/svg/list/pm-logos/itrip.png', alt: 'iTrip' },
  { src: '/assets/svg/list/pm-logos/evolve.png', alt: 'Evolve' },
  {
    src: '/assets/svg/list/pm-logos/prime-vacatio.png',
    alt: 'Prime Vacations',
  },
];

const allLogos = [...logos, ...logos, ...logos];

export const TrustedBySection: React.FC = () => (
  <div className="bg-[#D7D8D2] w-full">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-14 pb-2">
      <Typography
        variant="body1"
        component="p"
        className="text-center text-primary-main !text-xl sm:!text-2xl !font-medium mb-6"
      >
        Trusted by leading property managers
      </Typography>
    </div>
    {/* Logo Marquee */}
    <div className="overflow-hidden pb-16">
      <div
        className="flex items-center gap-16 animate-partner-marquee"
        style={{ width: `${allLogos.length * 12}rem` }}
      >
        {allLogos.map((logo, idx) => (
          <div key={idx} className="flex items-center min-w-[10rem]">
            <Image
              src={logo.src}
              alt={logo.alt}
              width={160}
              height={48}
              className="h-10 sm:h-12 w-auto object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);
